import React from 'react';

import { cn } from '@shared/utils/lib/ui';

import { AssetColors } from '@utils/assets';

import Color from 'color';
import { AUDCurrency } from 'src/assets/currency/AUDCurrency';
import { NZDCurrency } from 'src/assets/currency/NZDCurrency';
import { USDCurrency } from 'src/assets/currency/USDCurrency';

import { ThumbnailProps, getAssetIconSize } from './Thumbnail.styles';

const ThumbnailAsset: React.FC<Pick<ThumbnailProps, 'size' | 'assetCode'>> = ({ size, assetCode = 'UNKNOWN' }) => {
  if (assetCode === 'AUD') {
    return <AUDCurrency className='h-full w-full origin-top-left scale-150' />;
  }

  if (assetCode === 'USD') {
    return <USDCurrency className='h-full w-full origin-top-left scale-150' />;
  }

  if (assetCode === 'NZD') {
    return <NZDCurrency className='h-full w-full origin-top-left scale-150' />;
  }

  return (
    <i
      style={{
        color:
          Color(AssetColors[assetCode]).luminosity() > 0.7 // check if colour contrast is sufficient, if not use inverse foreground colour
            ? getComputedStyle(document.body).getPropertyValue('--color-nftnoir-400')
            : getComputedStyle(document.body).getPropertyValue('--color-lightgrey-100'),
      }}
      className={cn(`icon h-full w-full icon-${assetCode}`, getAssetIconSize(size))}
    />
  );
};

export { ThumbnailAsset };
